/** Hi-Lo's odds: a tie counts as right either way, so both include it. */
export function hiloOdds(card: number, min = 1, max = 12): { higher: number; lower: number } {
  const range = max - min + 1;
  return { higher: (max - card + 1) / range, lower: (card - min + 1) / range };
}

/** What a rung is worth, rounded the way the server rounds. */
export function hiloValue(base: number, ladder: readonly number[], rung: number): number {
  const step = ladder[rung];
  if (step === undefined) throw new Error(`No rung ${rung} on the ladder`);
  return Math.round(base * step);
}
